<script setup>
const { data: programWishlists } = useApiFetch("wishlists", {
  method: "GET",
  key: "program-wishlists",
  query: { entityType: "program" },
  transform(wishlists) {
    return wishlists?.data;
  },
});

const { data: universityWishlists } = useApiFetch("wishlists", {
  method: "GET",
  key: "university-wishlists",
  query: { entityType: "university" },
  transform(wishlists) {
    return wishlists?.data;
  },
});
</script>
<template>
  <Tabs value="0">
    <TabList>
      <Tab value="0">Programs: </Tab>
      <Tab value="1">Universities: </Tab>
    </TabList>
    <TabPanels>
      <TabPanel value="0">
        <div
          class="my-4 space-y-4 overflow-auto md:px-6"
          :style="{ maxHeight: 'calc(100vh - 160px)' }"
        >
          <MiniProgramCard
            v-for="wishlist in programWishlists"
            :key="wishlist?.id"
            :program="wishlist?.program"
            :wishlistId="wishlist?.id"
          />
          <div
            class="h-40 flex items-center justify-center"
            v-if="programWishlists?.length < 1"
          >
            <div class="text-center space-y-3">
              <i class="pi pi-book text-2xl"></i>
              <p class="text-sm text-muted">No Program</p>
            </div>
          </div>
        </div>
      </TabPanel>
      <TabPanel value="1">
        <div
          class="my-4 space-y-4 overflow-auto md:px-6"
          :style="{ maxHeight: 'calc(100vh - 160px)' }"
        >
          <MiniUniversityCard
            v-for="wishlist in universityWishlists"
            :key="wishlist?.id"
            :university="wishlist?.university"
            :wishlistId="wishlist?.id"
          />
          <div
            class="h-40 flex items-center justify-center"
            v-if="universityWishlists?.length < 1"
          >
            <div class="text-center space-y-3">
              <i class="pi pi-building text-2xl"></i>
              <p class="text-sm text-muted">No university</p>
            </div>
          </div>
        </div>
      </TabPanel>
    </TabPanels>
  </Tabs>
</template>
